import { API } from '.'
import { get, set } from 'lodash';

export default {
   get: (dateRange) => {
      return API.get('satelliteImages', {
            params: {
               start: dateRange[0].toISOString(),
               end: dateRange[1].toISOString()
            }
         })
         .then(res => {
            return []
               .concat(res.data)
               .map(image => {
                  set(image, 'metadata.acquisitionTime', new Date(get(image, 'metadata.acquisitionTime')))
                  return image
               })
               .reverse()
         });
   }
}


// WEBPACK FOOTER //
// ./src/api/satellite.js